module.exports = __webpack_public_path__ + "static/media/2.ddde1b44.svg";